// src/menu-items/index.jsx
import { useEffect, useMemo, useState } from 'react';
import iconMap from './iconMap';
import { http } from '@/api/http';

function buildTree(flat) {
  const byParent = new Map();
  flat.forEach(it => {
    const pk = it.parent_key || '__root__';
    if (!byParent.has(pk)) byParent.set(pk, []);
    byParent.get(pk).push(it);
  });

  const groups = flat.filter(x => x.type === 'group');

  if (groups.length === 0) {
    const children = (byParent.get('__root__') || [])
      .filter(x => x.type !== 'group')
      .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
      .map(toItemNode);

    return [{
      id: 'group-navegacion',
      title: 'Navegación',
      type: 'group',
      icon: 'AppstoreAddOutlined',
      children
    }];
  }

  return groups
    .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
    .map(g => {
      const children = (byParent.get(g.key) || [])
        .filter(x => x.type === 'item')
        .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
        .map(toItemNode);

      return {
        id: g.key,
        title: g.title,
        type: 'group',
        icon: g.icon || 'AppstoreAddOutlined',
        children
      };
    });
}

function toItemNode(it) {
  return {
    id: it.key,
    title: it.title,
    type: 'item',
    url: it.url || '#',
    icon: it.icon || 'AppstoreAddOutlined', // ← usa lo que viene del backend
  };
}

export function useMenuItems() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let canceled = false;

    (async () => {
      try {
        setLoading(true);
        const { data } = await http.get('/access/my-menu'); // ← usa tu endpoint existente
        const flat = Array.isArray(data?.data) ? data.data : [];
        const tree = buildTree(flat);

        const attachIcons = (node) => {
          const fallback = iconMap.AppstoreAddOutlined;
          if (node.type === 'group') {
            return {
              ...node,
              icon: iconMap[node.icon] || fallback,
              children: (node.children || []).map(attachIcons)
            };
          }
          const IconCmp = iconMap[node.icon] || fallback;
          if (!iconMap[node.icon]) {
            console.warn('[menu] Icono no encontrado en iconMap:', node.icon, 'para key:', node.id);
          }
          return { ...node, icon: IconCmp };
        };

        const withIcons = tree.map(attachIcons);
        if (!canceled) setItems(withIcons);
      } catch (e) {
        if (!canceled) {
          setError(e);
          setItems([]);
        }
      } finally {
        if (!canceled) setLoading(false);
      }
    })();

    return () => { canceled = true; };
  }, []);

  return useMemo(() => ({ menuItems: { items }, loading, error }), [items, loading, error]);
}

export default function menuItemsStatic() {
  return { items: [] };
}
